/* eslint-disable eqeqeq */
import React from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withSnackbar } from 'notistack';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Button as DxButton } from 'devextreme-react/button';
import Spinner from '../../../../partials/layout/Spinner';
import * as inspectionDefectCrud from '../../../../crud/inspectionDefect.crud';
import * as taskOrderCrud from '../../../../crud/taskOrder.crud';
import moment from 'moment';
import { injectIntl } from "react-intl";
import { Alert } from "react-bootstrap";
import { subYears } from 'date-fns';
import * as earlyWarningCrud from '../../../../crud/earlyWarning.crud';
import * as projectOrderCrud from '../../../../crud/projectOrder.crud';
import TemplateHelper from "../../../../Templates/TemplateHelper";
import DataSource from 'devextreme/data/data_source';
import Common from '../../../../shared/common';
class CompensationCustomForm extends React.Component {
    constructor(props) {
        super(props);
        this.createDefaultSubject = (((props.location || {}).state || {}).itemCustomProps || {}).subject;
        this.createDefaultAsset = (((props.location || {}).state || {}).itemCustomProps || {}).assetid;
        this.createDefaultFields = ((props.location || {}).state || {});

        let initialRelatedWarnings = [];
        if (props.relatedWarnings) {
            initialRelatedWarnings = [...props.relatedWarnings];
        }

        let selectedClause = null;
        let globalResources = this.props.globalResources;

        const { fields } = props.workflowItem;

        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        const createDefaultClause = (((props.location || {}).state || {}).itemCustomProps || {}).clauseDisplay;

        if (fields.Type?.clauses) {
            if (createDefaultClause) {
                selectedClause = fields.Type.clauses.find(
                    c => c.display === createDefaultClause
                );
            }
            else if (props.item?.compensationtype) {
                selectedClause = fields.Type.clauses.find(
                    c => c.display === props.item.compensationtype
                );
            }

            if (selectedClause) {
                globalResources = TemplateHelper.getGlobalResourcesOverriden(
                    globalResources,
                    selectedClause
                );
            }
        }

        this.state = {
            earlyWarningList: null,
            relatedWarnings: initialRelatedWarnings,
            taskOrderOptions: null,
            projectOrderOptions: null,
            selectedClause,
            globalResources,
        };
    }
    componentDidMount() {
        const { fields } = this.props.workflowItem;
        if (fields.TaskOrder.visible) {
            this.fetchTaskOrders();
        }
        if (fields.ProjectOrder.visible) {
            this.fetchProjectOrders();
        }
        if (fields.EarlyWarning.visible) {
            this.fetchEarlyWarnings();
        }
    }
    fetchEarlyWarnings = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await earlyWarningCrud.getEarlyWarningsToSelectList(companyid, projectid, contractid)
            this.setState({ earlyWarningList: responseObj }, () => this.addWarningItemIfConditionsMet(responseObj));
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }

    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.relatedWarnings !== this.props.relatedWarnings) {
            this.setState({ relatedWarnings: [...this.props.relatedWarnings] });
        }
    }


    fetchTaskOrders = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: responseObj } = await taskOrderCrud.getTaskOrdersToSelectList(contractid);
            //COVERTED TO DATASOURCE WITH FD-11007 DUE TO PERFORMENCE ISSUES AFTER 3K ITEMS
            const taskOrderOptions = new DataSource({
                store: {
                    type: 'array',
                    data: responseObj,
                    key: 'value'
                }
            });
            this.setState({ taskOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchProjectOrders = async () => {
        try {
            const { contractid, ispackaged } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);
            const projectOrderOptions = responseObj.map(TO => {
                let displayValue = "";
                if (ispackaged) {
                    if (TO.linkedprojectcode) {
                        displayValue += `[${TO.linkedprojectcode}] - `;
                    }
                    if (TO.linkedprojectname) {
                        displayValue += `${TO.linkedprojectname} - `;
                    }
                    if (TO.projectordernumber) {
                        displayValue += `${TO.projectordernumber} - `;
                    }
                    if (TO.purchaseordervalue) {
                        displayValue += `${Common.FormatCurrencyNum(TO.purchaseordervalue, (this.props.contract || {}).currency)} - `;
                    }
                }
                displayValue += `${TO.referenceid} - ${TO.subject}`;
                return {
                    value: TO.projectorderid,
                    reference: TO.referenceid,
                    display: displayValue
                }
            });
            this.setState({ projectOrderOptions: projectOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fieldChanged = (field, value, isDxFormValid, selectedItem) => {
        if (field) {
            if (field === 'Warning' && value) {
                this.addWarningItem(value);
            }
            else {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, selectedItem);
                    if (field === 'taskorderid') {
                        if (value) {
                            this.props.valueChangeHandler('taskorderid', value, isDxFormValid, selectedItem);
                            if (selectedItem) {
                                this.props.valueChangeHandler('taskorderreference', selectedItem.referenceid, isDxFormValid, selectedItem);
                            }
                        }
                        else {
                            this.props.valueChangeHandler('taskorderid', value, isDxFormValid, selectedItem);
                            this.props.valueChangeHandler('taskorderreference', "", isDxFormValid, selectedItem);
                        }
                    }
                    if (field === 'projectorderid') {
                        if (value) {
                            this.props.valueChangeHandler('projectorderid', value, isDxFormValid, selectedItem);
                            if (selectedItem) {
                                this.props.valueChangeHandler('projectorderreference', selectedItem.reference, isDxFormValid, selectedItem);
                            }
                        }
                        else {
                            this.props.valueChangeHandler('projectorderid', value, isDxFormValid, selectedItem);
                            this.props.valueChangeHandler('projectorderreference', "", isDxFormValid, selectedItem);
                        }
                    }

                }
                if (field === 'compensationtype') {
                    let selectedClause = null;
                    let globalResources = this.props.globalResources;
                    const { fields } = this.props.workflowItem;
                    if (value) {
                        selectedClause = fields.Type.clauses.find(c => c.display === value);
                        if (selectedClause) {
                            globalResources = TemplateHelper.getGlobalResourcesOverriden(globalResources, selectedClause)
                        }
                    }
                    this.setState({ selectedClause, globalResources })
                }
            }
        }

    }
    renderWarningItem = (warning) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <DxButton style={{ marginLeft: 8, fontSize: '8px' }}
                    icon="close"
                    hint="Remove"
                    onClick={() => this.removeWarningItem(warning.warningid)}
                />
                <Link to={warning.url}><span style={{ padding: 8, whiteSpace: 'nowrap' }}><strong>{warning.reference}</strong> {warning.title}</span></Link>
            </div>
        );
    }

    addWarningItemIfConditionsMet = (ewList) => {
        const { currentModelType } = this.props.workflowItem.config;

        //AUTO-SELECT EW DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
        if (this.createDefaultFields && this.createDefaultFields.itemBaseProps && this.createDefaultFields.itemBaseProps.reftype === 'EarlyWarning' && ewList) {
            const ewOption = ewList.find(x => x.warningid == this.createDefaultFields.itemBaseProps.refid);
            if (ewOption) {
                const { contractid } = this.props.contract;
                const relatedWarnings = [...this.state.relatedWarnings];
                const ewItem = ewList.find(ew => ew.warningid == this.createDefaultFields.itemBaseProps.refid);
                const url = `/contract/${contractid}/early-warning/${ewItem.party === 'PM' ? 'pm' : 'supplier'}/${ewItem.warningid}`;

                const newWarningItem = {
                    warningid: ewItem.warningid,
                    title: ewItem.title,
                    url: url,
                    reference: ewItem.referenceid
                };
                relatedWarnings.push({ ...newWarningItem });

                this.setState({ relatedWarnings: relatedWarnings }, this.updateParentWarnings.bind(this, ewItem.warningid));
            }
        }
    }

    addWarningItem = (warningid) => {
        const { contractid } = this.props.contract;
        const relatedWarnings = [...this.state.relatedWarnings];
        const ewItem = this.state.earlyWarningList.find(ew => ew.warningid === warningid);
        const url = `/contract/${contractid}/early-warning/${ewItem.party === 'PM' ? 'pm' : 'supplier'}/${ewItem.warningid}`;

        const newWarningItem = {
            warningid: ewItem.warningid,
            title: ewItem.title,
            url: url,
            reference: ewItem.referenceid
        };
        relatedWarnings.push({ ...newWarningItem });

        this.setState({ relatedWarnings: relatedWarnings }, this.updateParentWarnings.bind(this, ewItem.warningid));
    }
    updateParentWarnings = (addedWarningID, removedWarningID) => {
        if (this.props.onWarningsChanged) {
            this.props.onWarningsChanged(addedWarningID, removedWarningID);
        }
    }
    removeWarningItem = (warningid) => {
        const relatedWarnings = [...this.state.relatedWarnings];
        const removedIndex = relatedWarnings.findIndex(dt => dt.warningid === warningid);

        relatedWarnings.splice(removedIndex, 1);
        this.setState({ relatedWarnings: relatedWarnings }, this.updateParentWarnings.bind(this, null, warningid));
    }
    onSubmitHandler = (compensation, setSubmitting) => {
        if (this.props.onSubmitHandler) {
            delete compensation.Warning;
            if (compensation.inspectiondefectid) {
                compensation.projectmanagementinstructionsequence = this.state.instructionOptions.find(x => x.value === compensation.inspectiondefectid).reference;
            }

            this.props.onSubmitHandler(compensation, setSubmitting, [...this.state.relatedWarnings]);
        }
    }

    render() {
        const { fields } = this.props.workflowItem;
        if (
            (fields.TaskOrder.visible && !this.state.taskOrderOptions) ||
            (fields.ProjectOrder.visible && !this.state.projectOrderOptions) ||
            (fields.EarlyWarning.visible && (!this.state.relatedWarnings || !this.state.earlyWarningList))
        ) {
            return (<Spinner />);
        }

        const { currentModelType } = this.props.workflowItem.config;

        const createFormConfig = {
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };
        if (fields.Subject.visible) {
            createFormConfig.fields.push({ label: fields.Subject.label, dataField: 'compensationnumber', editorOptions: { defaultValue: this.createDefaultSubject } })
        }
        if (fields.Type.visible) {
            createFormConfig.fields.push({ label: fields.Type.label, dataField: 'compensationtype', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses, valueExpr: 'display', displayExpr: 'display', defaultValue: this.state.selectedClause?.display } })
        }
        if (fields.TaskOrder.visible) {
            //AUTO-SELECT TASK ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            let defaultTaskOrderSelection = null;
            if (this.createDefaultFields?.itemBaseProps?.reftype === 'TaskOrder') {
                defaultTaskOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
            }

            createFormConfig.fields.push({ label: fields.TaskOrder.label, dataField: 'taskorderid', editorType: 'dxSelectBox', required: fields.TaskOrder.required, editorOptions: { dataSource: this.state.taskOrderOptions, valueExpr: 'taskorderid', displayExpr: 'display', defaultValue: defaultTaskOrderSelection } });
        }
        if (fields.ProjectOrder.visible) {
            //AUTO-SELECT PROJECT ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            let defaultProjectOrderSelection = null;
            if (this.createDefaultFields?.itemBaseProps?.reftype === 'ProjectOrder') {
                defaultProjectOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
            }

            createFormConfig.fields.push({ label: fields.ProjectOrder.label, dataField: 'projectorderid', editorType: 'dxSelectBox', required: fields.ProjectOrder.required, editorOptions: { dataSource: this.state.projectOrderOptions, valueExpr: 'value', displayExpr: 'display', defaultValue: defaultProjectOrderSelection } });
        }
        if (fields.Note.visible) {
            createFormConfig.fields.push({ note: fields.Note.label });
        }
        if (fields.Description.visible) {
            createFormConfig.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor' });
        }


        if (fields.EarlyWarning.visible) {
            let availableOptions = this.state.earlyWarningList
                .filter(ew => this.state.relatedWarnings.findIndex(sew => sew.warningid === ew.warningid) === -1)
                .map(ew => {
                    return { value: ew.warningid, display: ew.referenceid + '  ' + ew.title };
                });

            const warningConfigGroup = {
                label: fields.EarlyWarning.label,
                fields: [
                    { label: this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.LABEL.SELECT_EW' }, { EARLY_WARNING: this.props.ewNotificationName }), dataField: 'Warning', required: false, editorType: 'dxSelectBox', editorOptions: { dataSource: availableOptions, valueExpr: 'value', displayExpr: 'display', placeholder: availableOptions.length === 0 ? this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.LABEL.NO_EW' }, { EARLY_WARNING: this.props.ewNotificationName }) : this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.LABEL.SELECT_EW' }, { EARLY_WARNING: this.props.ewNotificationName }) } }
                ]
            };
            const ewResorce = fields.EarlyWarning.label;
            this.state.relatedWarnings.forEach((warning, index) => {
                warningConfigGroup.fields.push({
                    label: `${ewResorce} ${index + 1}`,
                    render: () => this.renderWarningItem(warning)
                })
            });

            createFormConfig.fields.push(warningConfigGroup);
        }

        return (
            <>

                <BiDynamicForm
                    item={this.props.item}
                    config={createFormConfig}
                    onSubmitHandler={this.props.onSubmitHandler ? this.onSubmitHandler : null}
                    valueChangeHandler={this.fieldChanged}
                    customFields={this.props.customFields}
                    assetFieldsEnabled={this.props.assetFieldsEnabled}
                    assetid={this.createDefaultAsset}
                />
            </>
        );
    }
}

const mapStateToProps = store => ({
    // contract: store.contract.contract,
    // globalResources: store.contract.template.resources,
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(CompensationCustomForm)));